// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  itemId: __t.u64().primaryKey().name("item_id"),
  owner: __t.identity(),
  itemKey: __t.string().name("item_key"),
  name: __t.string(),
  quality: __t.u32(),
  ceiling: __t.u32(),
  propsJson: __t.string().name("props_json"),
  componentsJson: __t.string().name("components_json"),
  craftedBy: __t.identity().name("crafted_by"),
  serial: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
